import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'input-date',
  templateUrl: 'inputDate.component.html',
  styleUrls: ['inputDate.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true,
    },
  ],
})
export class InputDateComponent extends ControlValueAccessorDirective {
  @Input() placeholder: string = '';
  @Input() public readonly: boolean = false;
  // minDate: string = new Date().toISOString().split('T')[0]; // Today's date in 'YYYY-MM-DD' format

  constructor() {
    super();

  }
}
